import { ReactElement } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import { StaticQrCodeData } from '~/types/qrCode';

import { MobileStaticContentComponent } from './components/MobileStaticContentComponent';
import { StaticContentComponent } from './components/StaticContentComponent';

interface StaticQrContentLayoutProps {
  isNextProcessing?: boolean;
  qrCode?: StaticQrCodeData;
  activeStep?: number;
  handleStep?: (step: number) => void;
  mockup?: ReactElement;
  form?: ReactElement;
  isValid?: boolean;
  defaultView?: 'PHONE' | 'QRCODE';
  isDisabledQrCodePreview?: boolean;
  isMobileQrButtonHidden?: boolean;
}
export const StaticQrContentLayout = (props: StaticQrContentLayoutProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_MIN_WIDTH));

  const ContentComponent = isDesktop ? StaticContentComponent : MobileStaticContentComponent;

  return <ContentComponent {...props} />;
};
